import {useEffect, useMemo, useState, useRef} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import MainLayout from "../../../../commons/layout/MainLayout/index";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import Children from "./Children";
import Character from './Character';
import {useCharacter} from "../../../../commons/customHooks/Character";
import API, {ROUTES} from "../../../../commons/api/api";
import {updateChildrenProfileSuccess} from "../../../Account/redux/actions";
import ROUTERS from "../../../../commons/constans/router";

const ChildrenSettingComponent = ({userInfo}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [listChildren, setListChildren] = useState([]);

    const CURRENT_YEAR = new Date().getFullYear();

    const [tabPage, SetTabPage] = useState('children');// children and character

    const [listFavoriteCharacter, setListFavoriteCharacter] = useState([]);

    const paramsListCharacter = useMemo(() => ({
        per_page: 0,
    }), [])
    const [characterModels] = useCharacter(paramsListCharacter);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (userInfo.childrens && userInfo.childrens.length > 0) {
            let childrens = [...listChildren]
            userInfo.childrens.map(item => {
                childrens.push({
                    id: item.id,
                    age: item.age,
                    gender: item.gender || "M"
                })
            })
            setListChildren(childrens);
        }

        if (userInfo.favorite_characters && userInfo.favorite_characters.length > 0) {
            setListFavoriteCharacter(userInfo.favorite_characters)
        }

    }, []);

    useEffect(() => {
        if (tabPage === 'character') {
            window.scrollTo(0, 0);
        }
    }, [tabPage]);


    const handleSetListChildren = (childrens) => {
        setListChildren(childrens);
    }

    const handleSetTabPage = (tab) => {
        SetTabPage(tab);
    }

    const updateChildrenProfile = characters => {

        let registerChildrenTemporary = {
            childrens: listChildren,
            characters: characters
        };

        API.post(ROUTES.API_CUSTOM_INFORMATION, registerChildrenTemporary).then(res => {

            API.get(ROUTES.API_UPDATE_AUTH_ME).then(response => {
                let user = response.data.data;
                dispatch(updateChildrenProfileSuccess(user));
                if (location.state?.pathName === 'home') {
                    navigate(ROUTERS.HOME);
                }else if(location.state){
                    return navigate(ROUTERS.AWARD_REGISTER, {state: {...location.state}});
                }else{
                    navigate(-1)
                }

            })
        })
    }

    return (
        <MainLayout
            pageID={`${tabPage === 'children' ? 'children-setting' : 'profile-information-page'}`}
            displayBottomNav={false}
        >
            <HeaderHs2
                title={"맞춤정보"}
                labelLeft={true}
                labelRight={false}
                // url={ROUTERS.HOME}
                handleLabelLeft={() => {

                    if(tabPage === 'character'){
                        return handleSetTabPage('children')
                    }

                    if (location.state && location.state?.pathName !== 'home') {
                        return navigate(ROUTERS.AWARD_REGISTER, {state: {...location.state}});
                    }else if(location.state && location.state?.pathName && location.state?.pathName === 'home'){
                        navigate(ROUTERS.HOME, {
                            state: {
                                menuStatus: false
                            }
                        });
                    }else{
                        navigate(ROUTERS.HOME, {
                            state: {
                                menuStatus: true
                            }
                        });
                    }
                }}
            />
            <div className="wrapper">

                {tabPage === 'children' ? <Children
                        listChildren={listChildren}
                        setListChildren={handleSetListChildren}
                        setTabPage={handleSetTabPage}
                        tabPage={tabPage}
                    /> :
                    <Character
                        characterModels={characterModels}
                        listFavoriteCharacter={listFavoriteCharacter}
                        updateChildrenProfile={updateChildrenProfile}
                    />
                }
            </div>
        </MainLayout>
    );
};

export default ChildrenSettingComponent;
